import Model from "./base/model";

class SimulationValue extends Model {
  resourceName() {
    return "simulation_values";
  }

  fields() {
    return {
      simulation_km_range_id: "",
      vehicle_type_id: "",
      vehicle_option_id: "",
      value: "",

      simulation_km_range: {jsonApi: "hasOne", type: "simulation_km_ranges"},
      vehicle_type: {jsonApi: "hasOne", type: "vehicle_types"},
      vehicle_option: {jsonApi: "hasOne", type: "vehicle_options"},
      values_add: {jsonApi: "hasMany", type: "simulation_values_add"},

    };
  }
}

export default new SimulationValue();
